import React, { useCallback, useEffect, useState } from 'react'
import Dialog from '../../../../dialog/Dialog'
import Form from '../Form/Form';
import { useDispatch, useSelector } from 'react-redux';
import { updateSubjectPreview, updateSubjectForm } from '../../../../../store/actions/subjects.actions';
import { getSubjectById } from '../../../../../services/subjects/subjects.service';
import { useParams } from 'react-router-dom';
import { handlerErrorV2 } from '../../../../../utils/errors';

const Preview = () => {
  const { curriculumId } = useParams();
  const preview = useSelector((state) => state?.subject?.preview || null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const dispatch = useDispatch()

  const onLoad = useCallback(async () => {
    if (preview) {
      try {
        const response = await getSubjectById(curriculumId, preview)
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred')
        } else {
          dispatch(updateSubjectForm(response?.data || {}))
        }

      } catch (error) {
        const message = handlerErrorV2(error)
        setError(message)
      } finally {
        setLoading(false)
      }
    }
  }, [curriculumId, preview])

  const onClose = () => {
    dispatch(updateSubjectPreview())
    dispatch(updateSubjectForm({}))
  }

  useEffect(() => {
    onLoad()
  }, [onLoad])

  if (!preview) return <></>

  return (
    <Dialog
      id="subject-preview"
      show={!!preview} 
      title="Subject preview"
      onClose={onClose}
      onCloseHeader={true}
      maxWidth='sm'
    >
      { error ?
        <div>{error}</div>
      : <Form isPreview={true} isLoading={loading} />
      }
    </Dialog>
  )
}

export default Preview